// Landing CyberHealth Entry Point
// This file is the entry point for the landing page specific styles

import './scss/landing-cyberhealth.scss';

// Import only necessary Bootstrap components
import Collapse from 'bootstrap/js/dist/collapse';  // For FAQ Accordion
import Modal from 'bootstrap/js/dist/modal';        // For Terms Modal in order form

// Import Stimulus for terms-modal controller (needed for order form)
import { Application } from '@hotwired/stimulus';
import TermsModalController from './controllers/terms-modal_controller';
import $ from "jquery";

// Initialize Stimulus app with minimal footprint
const application = Application.start();

// Debug mode - log when controllers are registered and connected
if (process.env.NODE_ENV !== 'production') {
    application.debug = true;
}

application.register('terms-modal', TermsModalController);

console.log('Landing CyberHealth: Stimulus application started', application);
console.log('Landing CyberHealth: terms-modal controller registered');

// Initialize accordion when DOM is ready (minimal footprint)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLanding);
} else {
    initLanding();
}

function initLanding() {
    // Accordion is auto-initialized by Bootstrap data attributes
    // No manual initialization needed
    // console.log('Landing CyberHealth loaded and initialized');
    // To Scroll Top
    $("#backToTop").hide();
    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 200) {
                $('#backToTop').fadeIn();
            } else {
                $('#backToTop').fadeOut();
            }
        });
        // scroll body to 0px on click
        $('#backToTop').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 100);
            return false;
        });
    });
}
